// The one filter chip of a timeline (shared/_timeline_filter): marks the
// picked menu row and makes the chip say what it is filtered to - its icon,
// label and count - lit while it narrows anything. Counts are the caller's:
// Activity's grow as older pages load.
export function syncFilterChip(trigger, items, active, counts = new Map()) {
    let picked = null
    items.forEach((item) => {
        const on = (item.dataset.source || "all") === active
        item.classList.toggle("is-active", on)
        item.setAttribute("aria-pressed", on ? "true" : "false")
        item.querySelector(".msg-chip-submenu-check")?.toggleAttribute("hidden", !on)
        const badge = item.querySelector(".msg-chip-count")
        if (badge && counts.has(item.dataset.source)) badge.textContent = counts.get(item.dataset.source)
        if (on) picked = item
    })
    if (!trigger || !picked) return

    trigger.classList.toggle("is-active", active !== "all")
    const icon = trigger.querySelector("[data-filter-chip='icon']")
    if (icon) icon.className = `bi contact-activity-filter-icon ${picked.dataset.icon || ""}`
    const label = trigger.querySelector("[data-filter-chip='label']")
    if (label) label.textContent = picked.dataset.label || ""
    const count = trigger.querySelector("[data-filter-chip='count']")
    if (count) count.textContent = picked.querySelector(".msg-chip-count")?.textContent || ""
}
